"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheHeartBehindTheHealing() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="234012" id="the-matt-standard" className="dark bg-background py-16 md:py-24 lg:py-28 relative overflow-hidden" ref={ref}>
      <div className={`max-w-[1280px] mx-auto px-6 lg:px-12 transition-all duration-1000 ease-out motion-reduce:transition-none motion-reduce:transform-none ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 xl:gap-16 items-center">
          {/* Left Column: Photo with Overlapping Badge */}
          <div className="lg:col-span-5 relative">
            <div className="relative h-[420px] max-h-[420px] w-full lg:h-auto lg:max-h-none lg:aspect-[4/5] overflow-hidden rounded-[14px] bg-[#1a1f24] shadow-[0_4px_20px_-2px_rgba(21,25,29,0.5)] border border-white/10">
              <img alt="New slate roof installed in Southampton by roofer Firststop Roofing Ltd" loading="eager" className="w-full h-full object-cover" src="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/10/new-tiled-roof-southampton.jpg" />
            </div>

            {/* Overlapping Gold Badge on bottom-right corner */}
            <div className="absolute -bottom-4 right-4 sm:right-6 md:-bottom-5 md:right-6 bg-primary text-primary-foreground rounded-[14px] px-5 py-3.5 shadow-lg flex flex-col justify-center pointer-events-none">
              <span className="font-default font-extrabold text-2xl sm:text-3xl leading-none tracking-tight">
                20+ Years
              </span>
              <span className="font-default font-semibold text-xs sm:text-sm tracking-normal mt-1 opacity-90">
                Hands-on experience
              </span>
            </div>
          </div>

          {/* Right Column: Narrative Content */}
          <div className="lg:col-span-7 flex flex-col justify-center pt-4 lg:pt-0">
            <p className="text-xs md:text-sm font-bold uppercase tracking-widest text-primary mb-3">
              MEET THE OWNER
            </p>

            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-6">
              The Matt Standard in Southampton
            </h2>

            <div className="space-y-4 text-white/75 text-base md:text-lg leading-relaxed font-default font-normal">
              <p>
                With over two decades of hands-on experience in the British construction industry, I founded Firststop Roofing Ltd on a simple principle: if a job is worth doing, it is worth doing to perfection.
              </p>
              <p>
                My approach combines traditional craftsmanship with modern engineering. We don't just build structures; we create lasting value for UK homeowners by ensuring every tile, brick, and timber meets my personal seal of approval.
              </p>
              <p>
                When you choose us, you are choosing a commitment to transparency, durability, and the highest level of professional integrity in every project we undertake in Southampton, Hampshire &amp; surrounding areas.
              </p>
            </div>

            {/* Signature Block with thin gold line above */}
            <div className="mt-8 pt-6 border-t border-primary/60">
              <h3 className="text-xl font-default font-bold text-white">
                Matt
              </h3>
              <p className="text-xs md:text-sm text-white/60 tracking-widest uppercase mt-1 font-default font-medium">
                Owner & Lead Craftsman
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}